<block-ui>
  <app-header [ngClass]="{'mobile-app': mobileApp == 'true'}"></app-header>
  <main [ngClass]="{'mobile-app': mobileApp == 'true'}">
    <router-outlet></router-outlet>
  </main>
  <app-footer [ngClass]="{'mobile-app': mobileApp == 'true'}"></app-footer>
</block-ui>
